module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_survey-82610340f3a29134256278568e02ac45.svg";